// extracted by mini-css-extract-plugin
export var progressBar = "_jj-0";
export var progressBarInner = "_jj-1";